import React from 'react';
import { themeGet } from '@styled-system/theme-get';
import _trimEnd from 'lodash-es/trimEnd';
import { ThemeContext } from 'styled-components';

export function useTheme() {
  return React.useContext(ThemeContext);
}

export function pxToNumber(value: string | number): number {
  if (typeof value === 'number') return value;
  if (!value || !value.endsWith('px')) return 0;
  return parseInt(_trimEnd(value, 'px'), 10);
}

export { themeGet };



// WEBPACK FOOTER //
// ../kibble/utils/index.ts